module.exports = __webpack_public_path__ + "static/media/check.4003e96a.png";